@if (detailData) {
  <div class="pt-2">
    <div class="card-body">
      <!-- Incident Delete Button -->
      <div
        [ngStyle]="{
          'padding-bottom': bottomSectionFixedHeight,
        }"
      >
        @if (!isIncidentSubmitted) {
          <div class="text-end px-2">
            <button (click)="deleteIncident()" class="btn btn-danger btn-sm">
              Delete
            </button>
          </div>
        }
        <!-- <div
        *ngIf="isIncidentSubmitted && detailData?.status === 1"
        class="text-end mb-2"
        >
        <button
          *ngIf="isAdmin || isDispatcher"
          (click)="reOpenReport()"
          class="btn btn-outline-warning btn-sm me-2"
          >
          Edit Report
        </button>
        <button
          (click)="markResolved(resolTimeTemplateRef)"
          class="btn btn-success btn-sm"
          >
          Resend Report
        </button>
      </div> -->
        <div class="row row-cols-1 row-cols-lg-2 mb-3">
          <div
            class="col col-lg-8 d-flex flex-wrap column-gap-5 row-gap-3 p-3 p-lg-4 border-lg border-lg-3 rounded"
          >
            <div>
              <dl>
                <dt>Incident ID</dt>
                <dd>{{ detailData?.incident_key }}</dd>
              </dl>
            </div>
            @if (detailData?.subscriber_user?.id !== subscriberUserId) {
              <div>
                <dl>
                  <div class="d-flex align-items-center">
                    <div>
                      <dt>Reported By</dt>
                      <dd>
                        {{ detailData?.subscriber_user?.full_name }}
                      </dd>
                    </div>
                  </div>
                </dl>
              </div>
            }
            <!-- Editable Incident Fields -->
            <div>
              <dl>
                <div class="d-flex align-items-center">
                  <div>
                    <dt>
                      Incident Type(s)
                      <span
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="This field specifies the type of incident that occurred."
                        ><i class="fa-solid fa-circle-info text-secondary"></i
                      ></span>
                    </dt>
                  </div>
                </div>
                <dd
                  [ngClass]="
                    isCreatedUser && !isIncidentSubmitted ? 'link-edit' : ''
                  "
                  (click)="
                    isCreatedUser && !isIncidentSubmitted
                      ? openupdateIncidentTypeTemplate(incidentTypeTemplateRef)
                      : ''
                  "
                >
                  @if (detailData?.incident_types?.length) {
                    @for (iType of detailData?.incident_types; track $index) {
                      <div>{{ iType?.name }}</div>
                    }
                  } @else if (detailData?.incident_type) {
                    {{ detailData?.incident_type }}
                  } @else {
                    <div class="text-danger">Not Added</div>
                  }
                </dd>
              </dl>
            </div>
            <div>
              <dl>
                <div class="d-flex align-items-center">
                  <div>
                    <dt>Time Of Incident</dt>
                    <dd
                      [ngClass]="
                        isCreatedUser && !isIncidentSubmitted ? 'link-edit' : ''
                      "
                      (click)="
                        isCreatedUser && !isIncidentSubmitted
                          ? openupdateIncidentTimeTemplate(
                              incidentTimeTemplateRef
                            )
                          : ''
                      "
                    >
                      {{ detailData?.incident_time | date: "d MMM y HH:mm" }}
                    </dd>
                  </div>
                </div>
              </dl>
            </div>
            <div>
              <dl>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <dt>Site</dt>
                    <dd
                      class="link-view"
                      (click)="openSiteView(detailData?.site)"
                    >
                      {{ detailData?.site?.company_name }} [{{
                        detailData?.company?.company_name
                      }}]
                    </dd>
                  </div>
                </div>
              </dl>
              <dl>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <dt>Address</dt>
                    <dd>
                      <a
                        class="link-view"
                        [href]="
                          'https://www.google.com/maps/search/?api=1&query=' +
                          detailData?.site?.address?.latitude +
                          ',' +
                          detailData?.site?.address?.longitude
                        "
                        target="_blank"
                      >
                        {{ detailData?.site?.address?.full_address }}
                      </a>
                    </dd>
                  </div>
                </div>
              </dl>
            </div>
            <div class="col-12">
              @if (detailData?.information) {
                <dl>
                  <div class="d-flex align-items-center">
                    <div>
                      <dt>Description</dt>
                    </div>
                  </div>
                  <dd
                    class="gt-multi-line"
                    [ngClass]="
                      isCreatedUser && !isIncidentSubmitted ? 'link-edit' : ''
                    "
                    (click)="
                      isCreatedUser && !isIncidentSubmitted
                        ? openExtraInfoTemplate(extraInfoTemplateRef, 'an')
                        : ''
                    "
                  >
                    {{ detailData?.information }}
                  </dd>
                </dl>
              }
            </div>
            <div class="col-12">
              @if (detailData?.corrective_actions) {
                <dl>
                  <div class="d-flex align-items-center">
                    <div>
                      <dt>Resolution</dt>
                    </div>
                  </div>
                  <dd
                    class="gt-multi-line"
                    [ngClass]="
                      isCreatedUser && !isIncidentSubmitted ? 'link-edit' : ''
                    "
                    (click)="
                      isCreatedUser && !isIncidentSubmitted
                        ? openExtraInfoTemplate(extraInfoTemplateRef, 'ca')
                        : ''
                    "
                  >
                    {{ detailData?.corrective_actions }}
                  </dd>
                </dl>
              }
            </div>
            <!-- Updates & Photos Section -->
            @if (incidentCommentFiles?.length) {
              <div class="col-12 col-lg-8">
                <div class="text-end my-3">
                  <button
                    class="btn btn-sm btn-dark"
                    (click)="toggleSortOrder()"
                    [disabled]="incidentCommentFiles?.length < 2"
                  >
                    Sort
                    <span>
                      <i class="fa-solid fa-sort"></i>
                    </span>
                  </button>
                </div>
                <div class="row row-cols-1">
                  @if (incidentCommentFiles?.length) {
                    @for (
                      msg of sortedIncidentCommentFiles;
                      track msg;
                      let i = $index
                    ) {
                      <div
                        class="d-flex flex-column flex-wrap border rounded p-2 mb-2 shadow"
                      >
                        <dl
                          class="mb-0"
                          [ngClass]="msg?.is_deleted ? 'opacity-50' : ''"
                        >
                          <dt>
                            <!--update details section-->
                            {{ msg?.updated_at | date: "d MMM y HH:mm" }}
                            {{
                              subscriberUserId == msg?.subs_user_id
                                ? ""
                                : "| " + msg?.user_name
                            }}
                            @if (
                              msg?.history_changes?.length &&
                              (subscriberUserId == msg?.subs_user_id ||
                                isAdmin ||
                                isDispatcher)
                            ) {
                              <span>
                                | Edited [{{
                                  (
                                    msg?.history_changes
                                    | misc: "lastCommentEditedDateTime"
                                  )?.updated_at | date: "d MMM y HH:mm"
                                }}]</span
                              >
                            }
                            @if (msg?.file) {
                              <span>
                                | Source
                                {{
                                  msg?.event_action === 11
                                    ? "[Device Library]"
                                    : "[Camera]"
                                }}
                              </span>
                            }
                            @if ([8, 9].includes(msg?.event_action)) {
                              <span> | Report Sent </span>
                            }
                            @if (isCreatedUser && !isIncidentSubmitted) {
                              <span
                                class="float-end me-2"
                                (click)="
                                  deleteRestoreUserUpdate({
                                    event: msg,
                                    type: msg?.is_deleted
                                      ? 'restore'
                                      : 'delete',
                                  })
                                "
                              >
                                @if (msg?.is_deleted) {
                                  <span>
                                    <i
                                      class="fa-regular fa-square-plus md-font-size text-secondary"
                                    ></i>
                                  </span>
                                } @else {
                                  <span>
                                    <i
                                      class="fa-regular fa-square-minus md-font-size text-secondary"
                                    ></i>
                                  </span>
                                }
                              </span>
                            }
                          </dt>
                          <dd class="mb-1">
                            <!-- comment / photo -->
                            <div class="pb-3">
                              @if ([8, 9].includes(msg?.event_action)) {
                                <span><dt>Recipients:</dt></span>
                              }
                              <span
                                class="gt-multi-line"
                                [class.link-edit]="
                                  isCreatedUser &&
                                  !isIncidentSubmitted &&
                                  msg?.detail
                                "
                                (click)="
                                  isCreatedUser && !isIncidentSubmitted
                                    ? openCommentTemplate(commentRef, msg)
                                    : null
                                "
                              >
                                @if (
                                  (msg?.detail === "null" ||
                                    msg?.detail === "undefined" ||
                                    !msg?.detail) &&
                                  isCreatedUser &&
                                  !isIncidentSubmitted
                                ) {
                                  <div
                                    class="rounded border shadow p-1 px-5 text-center hover d-inline-block"
                                    role="button"
                                  >
                                    <i
                                      class="fa-solid fa-comment-dots text-body fa-2x"
                                    ></i>
                                  </div>
                                } @else {
                                  {{ msg?.detail }}
                                }
                              </span>
                            </div>
                            @if (msg?.file) {
                              <ng-template
                                *ngTemplateOutlet="
                                  filePreviewTemplate;
                                  context: { value: msg }
                                "
                              ></ng-template>
                            }
                          </dd>
                        </dl>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
          <div class="col-lg-3 d-none d-md-block mt-0">
            <ng-template
              *ngTemplateOutlet="incidentActionBtnsTemplate"
            ></ng-template>
          </div>
        </div>
      </div>
      <!-- Bottom Fixed Action Buttons -->
      <div id="fixedBtn" class="bottom-section-buttons row d-md-none pb-2">
        <ng-template
          *ngTemplateOutlet="incidentActionBtnsTemplate"
        ></ng-template>
      </div>
    </div>
  </div>
}

<!-- ADD COMMENT  DIALOG -->
<ng-template #commentRef let-commentRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="commentRef.close(); newValue = ''">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          maxlength="340"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="newValue"
          id="updateCommentBox"
        ></textarea>
        @if (newValue) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateCommentBox')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close(); newValue = ''"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          @if (data?.id && (data?.file || data?.file_url)) {
            <button
              class="btn btn-lg w-100"
              [disabled]="previousTextValue === newValue"
              (click)="editComment(data); commentRef.close()"
              [ngClass]="newValue ? 'btn-primary' : 'btn-danger'"
            >
              Update
            </button>
          } @else {
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="!newValue || previousTextValue === newValue"
              (click)="editComment(data); commentRef.close()"
            >
              {{ data?.id ? "Update" : "Add" }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- edit corrective actions/ additonal notes  DIALOG -->
<ng-template
  #extraInfoTemplateRef
  let-extraInfoTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card m-0">
    <div class="card-header">
      {{ data?.extrainfoType == "ca" ? "Resolution" : "Incident Details" }}
      <span class="float-end" (click)="extraInfoTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="form-group input-group my-2">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          maxlength="1500"
          placeholder="Start typing"
          autofocus
          [(ngModel)]="newValue"
          id="updateextrainfoType"
        ></textarea>
        @if (newValue) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateextrainfoType')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            (click)="extraInfoTemplateRef.close(); newValue = ''"
            class="btn btn-dark btn-lg w-100"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            (click)="updateExtraInfo(data); extraInfoTemplateRef.close()"
            class="btn btn-primary btn-lg w-100"
            [disabled]="previousTextValue === newValue"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- resolution time template-->

<ng-template
  #resolveTimeTemplate
  let-data
  let-resolveTimeTemplateRef="dialogRef"
>
  <div class="dialog-box card m-0">
    <div class="card-header">
      Submit Incident Report
      <span class="float-end" (click)="resolveTimeTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="scrollable-y">
      <!--incident Time section-->
      @if (resDateTimeErrorMessage) {
        <div class="mt-3">
          {{ resDateTimeErrorMessage }}
        </div>
      }

      <div class="form-floating mb-4">
        <input
          autofocus
          id="rDayField"
          class="form-control"
          placeholder="Resolution Date"
          type="datetime-local"
          [(ngModel)]="resolutionDay"
          (change)="formateStartDate($event)"
        /><label for="inputAssignee"> Resolution Date</label>
      </div>

      <div class="col">
        <button
          type="button"
          (click)="resolveTimeTemplateRef.close(); submitIncident()"
          class="btn btn-success btn-lg w-100"
          [disabled]="!resolutionDateTime || !hasUnsnubbedUsers()"
        >
          {{ isIncidentSubmitted ? "Send Report" : "Submit" }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!-- edit incident time  DIALOG -->
<ng-template
  #incidentTimeTemplateRef
  let-incidentTimeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Incident Time

      <span class="float-end" (click)="incidentTimeTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="col my-2">
        <div class="row row-cols-1">
          <div class="col">
            <div class="form-floating">
              <input
                id="mobiDayField"
                class="form-control"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Incident Date"
                type="datetime-local"
                (change)="formateNewStartDate($event)"
                [(ngModel)]="newDateValue"
              /><label for="mobiDayField"> Incident Date</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            (click)="incidentTimeTemplateRef.close(); newValue = ''"
            class="btn btn-dark btn-lg w-100"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            (click)="updateincidentTime(data); incidentTimeTemplateRef.close()"
            class="btn btn-primary btn-lg w-100"
            [disabled]="!newDateValue"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- edit incident type  DIALOG -->
<ng-template
  #incidentTypeTemplateRef
  let-incidentTypeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Incident

      <span class="float-end" (click)="incidentTypeTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <dl>
      <dt>Incident Type(s)</dt>
    </dl>
    <div class="d-flex flex-wrap gap-2">
      @for (
        incidentType of selectedIncidentTypeList;
        track incidentType;
        let i = $index;
        let l = $last
      ) {
        <div>
          @if (incidentType?.isFocused) {
            <ng-container>
              <div class="mb-3">
                <gtapp-auto-complete
                  [data]="incidentTypeList"
                  [maxLength]="256"
                  placeHolder="Search Incidents Type"
                  searchKeyword="name"
                  [initialValue]="previousincidentTypeValue"
                  [itemTemplate]="incidentTypeLookupTemplate"
                  [addInitialKey]="previousincidentTypeValue"
                  (inputChanged)="onSearchIncidentType($event)"
                  (selected)="onSelectIncidentType($event, i)"
                  inputId="iTypeLookupField"
                  [enableCloseOption]="true"
                  (fieldCleared)="openIncidentTypeLookup(i)"
                  (blurTriggered)="checkAndAddIncidentType(i)"
                >
                </gtapp-auto-complete>
              </div>
              <ng-template #incidentTypeLookupTemplate let-item>
                @if (item?.key === 0) {
                  <div>Add Incident Type</div>
                } @else {
                  <div>{{ item?.name }}</div>
                }
              </ng-template>
            </ng-container>
          } @else {
            <ng-container>
              <div class="border rounded p-1">
                <div class="d-flex align-items-center">
                  {{ incidentType?.name }}
                  <span (click)="deleteSiteKeyField(i)">
                    <i class="fa-solid fa-circle-minus text-danger ps-2"></i>
                  </span>
                </div>
              </div>
            </ng-container>
          }
        </div>
      }
    </div>
    @if (selectedIncidentTypeList?.length < 10) {
      <div class="text-end my-2">
        <button
          (click)="addNewSiteKeyField()"
          class="btn btn-primary"
          [disabled]="
            selectedIncidentTypeList?.length
              ? !selectedIncidentTypeList[selectedIncidentTypeList?.length - 1]
                  ?.name
              : true
          "
        >
          Add Incident Type
        </button>
      </div>
    }

    <div class="row row-cols-2 mt-2">
      <div class="col">
        <button
          (click)="incidentTypeTemplateRef.close(); newValue = ''"
          class="btn btn-dark btn-lg w-100"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          (click)="incidentTypeTemplateRef.close(); updateIncidentTypeList()"
          class="btn btn-primary btn-lg w-100"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #incidentActionBtnsTemplate>
  <div class="row">
    <div>
      @if (!detailData?.information && isCreatedUser && !isIncidentSubmitted) {
        <button
          class="btn btn-outline-primary btn-lg btn-block w-100"
          (click)="openExtraInfoTemplate(extraInfoTemplateRef, 'an')"
        >
          Incident Details
        </button>
      }
    </div>

    @if (isCreatedUser && !isIncidentSubmitted) {
      <div>
        <button
          class="btn btn-primary btn-lg btn-block w-100"
          (click)="openCamPopup()"
        >
          Attach Photo
        </button>
      </div>
      @if (!detailData?.corrective_actions) {
        <div>
          <button
            class="btn btn-success btn-lg btn-block w-100"
            (click)="openExtraInfoTemplate(extraInfoTemplateRef, 'ca')"
          >
            Resolution
          </button>
        </div>
      }
    }

    @if (!isIncidentSubmitted && (isCreatedUser || isAdmin || isDispatcher)) {
      <div>
        <button
          class="btn btn-outline-success btn-lg btn-block w-100"
          (click)="markResolved(resolveTimeTemplate)"
        >
          Submit Incident Report
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #filePreviewTemplate let-update="value" let-inBrowser="inBrowser">
  <div class="media-view mb-2" (click)="$event.stopImmediatePropagation()">
    @if ([".mp4", ".mov", ".webm", ".mkv"].includes(update?.file_extension)) {
      <video controls muted class="media-file">
        <source [src]="update?.file" />
        Your browser does not support the video tag.
      </video>
    } @else if ([".mp3"].includes(update?.file_extension)) {
      <audio
        [src]="update?.file"
        controls
        controlslist="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
      ></audio>
    } @else {
      <img
        (click)="onOpenImage($event, update)"
        [src]="update?.file"
        class="media-file"
      />
    }
  </div>
</ng-template>
